import styled from 'styled-components';

const TotalResults = styled.span`
  font-family: "Avenir Black", "Arial Black", sans-serif;
  letter-spacing: 1px;
  ${({ isDesktop }) => (isDesktop ? 'margin-right: 5px;' : null)};
`;

export default TotalResults;
